import type {
    AdminV2RevenueMenuVisibility,
    AdminV2RevenueMenuVisibilityKey,
} from "@/types/adminV2";

export const isRevenueMenuVisibilityEnabled = (
    menuVisibility:
        | Partial<Record<AdminV2RevenueMenuVisibilityKey, boolean>>
        | null
        | undefined,
    key: AdminV2RevenueMenuVisibilityKey,
): boolean => menuVisibility?.[key] === true;

export const resolveRevenueMenuVisibilityState = (
    menuVisibility:
        | Partial<Record<AdminV2RevenueMenuVisibilityKey, boolean>>
        | null
        | undefined,
): AdminV2RevenueMenuVisibility => ({
    revenue: isRevenueMenuVisibilityEnabled(menuVisibility, "revenue"),
    learning: isRevenueMenuVisibilityEnabled(menuVisibility, "learning"),
    sales: isRevenueMenuVisibilityEnabled(menuVisibility, "sales"),
});
